// extracted by css-extract-rspack-plugin
export default {"root":"PJKAyzEV6DM6Iy9O"};